// extracted by mini-css-extract-plugin
export default {"toggle":"report-management_toggle__lV7AB","card":"report-management_card__5LlIH","toggleCard":"report-management_toggleCard__Rfa27"};